export const HOME_URL = '/'
export const REWARD_URL = '/reward'
export const LOG_IN_URL = '/login'
export const FORGOT_PASSWORD_URL = '/forgot-password'
export const RESET_PASSWORD_URL = '/reset-password'
export const WELCOME_URL = '/welcome'
export const SIGNUP_URL = '/signup'
export const REDEEM_POINTS_URL = '/redeem-points'
export const SHOP_URL = '/shop'
export const MY_ITEMS_URL = '/my-items'
export const REDIRECT_URL = '/redirect'
export const SETTINGS_URL = '/settings'
export const TRANSACTIONS_URL = '/transactions'
export const PAGE_NOT_FOUND_URL = '/not-found'
export const EXCHANGE_POINTS_URL = '/exchange-points'
export const CASHBACK_URL = '/cashback'
export const BUY_POINTS_URL = '/buy-points'
export const EARN_POINTS_URL = '/earn-points'
export const STAKING_URL = '/staking'
export const QUESTS_URL = '/quests'
export const REWARD_BOXES_URL = '/reward-boxes'
export const MEMBERSHIP_URL = '/membership'
export const SCRATCH_CARDS_URL = '/scratch-cards'
export const POST_TO_EARN_URL = '/post-to-earn'
export const INVITE_FRIENDS_URL = '/invite-friends'
export const PLAY_GAMES_URL = '/play-games'
export const UNAUTHORIZED_URLS = [
  HOME_URL,
  REWARD_URL,
  LOG_IN_URL,
  FORGOT_PASSWORD_URL,
  RESET_PASSWORD_URL,
  SIGNUP_URL,
  EXCHANGE_POINTS_URL,
  CASHBACK_URL,
  BUY_POINTS_URL,
  EARN_POINTS_URL,
  STAKING_URL,
  QUESTS_URL,
  REWARD_BOXES_URL,
  SHOP_URL,
  MY_ITEMS_URL,
  MEMBERSHIP_URL,
  SCRATCH_CARDS_URL,
  POST_TO_EARN_URL,
  INVITE_FRIENDS_URL,
  PLAY_GAMES_URL
]
